import { DatabaseModel } from './database-model';
import { Media } from './media';

export class QuizAnswer extends DatabaseModel {
    // Unique identifier for question
    public key: string = '';
    // Headline or answer text
    public label: string = '';
    // Answer headline/title shown after answering
    public title: string = '';
    // Description / info text of the answer
    public info: string = '';
    // Media to illustrate the answer
    public media: Media = null;
    // Is this a correct answer
    public isCorrect: boolean = false;

    constructor(json: any = null, key: string = "") {
        super();
        this.fromJson(json);
        this.key = key ? key : this.genKey();
    }

    public toJson() {
        return {
            key: this.key,
            label: this.label,
            title: this.title,
            info: this.info,
            media: this.media ? this.media.toJson() : null,
            isCorrect: this.isCorrect
        }
    }

    public fromJson(json: any) {
        if(!json) return;

        this.key = json.key;
        this.label = json.label || '';
        this.title = json.title || '';
        this.info = json.info || '';
        this.isCorrect = json.isCorrect || false;
        this.media = json.media ? new Media(json.media, json.media.key) : null;
    }
}
